/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".row-yellow[_ngcontent-%COMP%]{background-color:#fff704;font-weight:400}.row-blue[_ngcontent-%COMP%]{background-color:#00b8ff;font-weight:400}"];
export { styles as styles };
